// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2SN-i","log":"ModalInventoryLogs_log__1yKSg","date":"ModalInventoryLogs_date__xiV9Y","userName":"ModalInventoryLogs_userName__3o-69"};